<script setup lang="ts">
import NeedAccessBg from "../assets/images/need-access-bg.jpg";
</script>

<template>
    <div
        class="h-full bg-cover bg-center rounded-xl flex flex-col items-stretch justify-between"
        :style="{ backgroundImage: `url(${NeedAccessBg})` }"
    >
        <div class="flex-1 flex items-center justify-center px-6">
            <div class="bg-cream-dark rounded-lg p-10 md:p-12 w-full max-w-[640px] shadow-sm">
                <h1 class="h1 mb-4">Request Access</h1>
                <div class="text-sm tracking-widest text-gray-600 mb-4">HOW TO GET STARTED</div>
                <ul class="list-disc pl-6 space-y-3 text-gray-800">
                    <li>Ask your accounting team to invite you to Properverse</li>
                    <li>You'll receive an email with a secure link</li>
                    <li>Follow the steps to create your password and log in</li>
                </ul>
            </div>
        </div>
        <div class="text-center text-[10px] py-4 text-gray-700 tracking-widest">
            PROPER AI © 2025
        </div>
    </div>
</template>
